// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"800bb28d","774":"96489f87"}[chunkId] + ".chunk.js";
};